module.exports = __webpack_public_path__ + "static/media/jira.1124c1c4.svg";